import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-translate-sms-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [isTranslator]="true"
      [templateType]="templateType"
      templateBasePath="/translate-sms-template/"
      channelLabel="SMS"
      namePlaceholder="Enter sms name"
      emptyMessage="No sms found!"
      heartbeatType="sms"
      [showResponsysButton]="true" />
  `
})
export class TranslateSmsTemplateComponent {
  protected readonly templateType = TypeEnum.SMS;
}
